/**
 * Whose approvals the inbox shows in this browser tab: the user's own (null) or a delegator's. Kept per tab so a
 * second tab can show your own inbox. The axios hook in global/axios.ts adds it as on_behalf_of to approval/* calls;
 * the API checks the delegation and shows only what it covers.
 */
const KEY = 'erp.approval.actingFor';
const EVENT = 'erp-acting-for';

export const getActingFor = (): string | null => {
  try {
    return sessionStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
};
export const setActingFor = (user: string | null) => {
  try {
    if (user) sessionStorage.setItem(KEY, user);
    else sessionStorage.removeItem(KEY);
  } catch {
    // private mode: acting-for stays off
  }
  window.dispatchEvent(new Event(EVENT));
};
export const onActingForChange = (fn: () => void) => {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
};
/** approval/* requests (the inbox) carry the delegator; approvalSetup/* and everything else do not */
export const addActingFor = (url: string | undefined, data: any) => {
  const who = getActingFor();
  if (!who || !url || !/^\/?approval\//.test(url)) return data;
  if (data && typeof data === 'object' && !(data instanceof FormData)) return { ...data, on_behalf_of: who };
  return data;
};
